module.exports = __webpack_public_path__ + "img/location-big.3c138695.png";